/**
 * Based on https://github.com/smeijer/leaflet-geosearch
 * @type {{}}
 */
Greenmile.Geocoding = Greenmile.Geocoding || {};

Greenmile.Geocoding.Bing = function() {
    return function (map, credentials) {

        const provider = new BingProvider({
            params: {
                key: credentials
            },
        });

        this.geocode = (addresToGeocode, geocodeResultCallback, geocodeErrorCallback) => {

            if (addresToGeocode ) {

                provider
                    .search({ query: addresToGeocode})
                    .then(function(result) {
                        geocodeResultCallback(result.map((item) => {
                            return {
                                formatted_address: item.label,
                                geometry: {
                                    location: {
                                        lat: () => item.y ,
                                        lng: () => item.x
                                    }
                                }
                            };
                        }));
                    }).catch(function(e) {
                        geocodeErrorCallback(e);
                    });

            } else {
                return "no address found";
            }

        };

    };
}();
